import { Space } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

// Drawer body renders on BRAND.electric (see appShellGlobalStyles). textMuted at
// rgba(255, 255, 255, 0.65) measures 6.93:1 against that background — comfortably
// above the 4.5:1 AA minimum for body text.
export const LoadingState = styled(Space)`
  width: 100%;
  justify-content: center;
  padding: 48px 0;
`;

export const LoadingHint = styled.span`
  color: ${APP_SHELL_THEME.textMuted};
  max-width: 360px;
  text-align: center;
`;

export const PreviewFrame = styled.iframe<{ $hidden: boolean }>`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  border: none;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'block')};
`;

/**
 * The document's own figures, above the rendered PDF.
 *
 * Separated by a rule rather than a card: it is a caption for the document
 * below it, not a panel competing with it.
 */
export const FactsBlock = styled.div`
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.12);

  .ant-descriptions-item-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    opacity: 0.65;
  }

  .ant-descriptions-item-content {
    font-variant-numeric: tabular-nums;
  }
`;
